module.exports = __webpack_public_path__ + "static/media/levels_5_2.4b3063f9.svg";